import { makeAutoObservable } from "mobx";
import { ModifiersGroup } from "../types/modifiersGroup.types";
import { openApi } from "../../../../helpers/request";

class ModifiersGroupsController {

    modifiersGroups: ModifiersGroup[] = []

    constructor() {
        makeAutoObservable(this)
    }

    GetModifiersGroups() {
        openApi('get', `/modifiers_groups`)
            .then(result => {
                this.modifiersGroups = Array.isArray(result.data) ? [...result.data].reverse() : []
            })
            .catch(err => {
                console.log(err.response)
            })
    }

    DeleteModifierGroup(id: number) {
        openApi('delete', `/modifiers_groups/${id}`)
            .then(() => {
                this.GetModifiersGroups()
            })
            .catch(err => {
                console.log(err.response)
            })
    }

}

export default new ModifiersGroupsController()